<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="bg-primary m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">Motivo del rechazo</span>
            <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
            <div class="mb-24" fxLayout="column" fxLayoutAlign="start">
                <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-around stretch"
                     fxLayoutAlign.sm="space-around stretch" fxLayoutAlign.xs="space-around stretch">
                        <mat-form-field appearance="outline" style="width: 100%">
                            <mat-label>Descripción del motivo</mat-label>
                            <textarea matInput [formControl]="observaciones" rows="7" placeholder="" maxlength="40000"></textarea>
                        </mat-form-field>
                </div>
            </div>
    </div>
    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
        <button mat-button mat-dialog-close>Cancelar</button>
        <button mat-raised-button color="accent" (click)="save()" [disabled]="!observaciones.valid">Guardar</button>
    </div>
</div>
